exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[_v-7a8cfd00]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-7a8cfd00&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Admin/Admin-order.vue
// module id = 445
// module chunks = 0